<div class="nd-content">
    <div class="nd-header">
        <div class="me-2">
            <p class="d-inline-block me-2">From Date</p>
            <input type="date" [(ngModel)]="fromDate" (ngModelChange)="getObservations()">
        </div>
        <div class="me-2 flex-grow-1">
            <p class="d-inline-block me-2">To Date</p>
            <input type="date" [(ngModel)]="toDate" (ngModelChange)="getObservations()">
        </div>
        <span class="d-flex align-items-center me-2">Last refresh: {{ lastRefresh | date: 'dd/MM/yyyy hh:mm:ss'
            }}</span>
        <div class="button mini outline wide" (click)="getObservations()" (keydown)="getObservations()">Refresh data</div>
    </div>
    <div class="tabs-container mt-2 mb-3">
        <div class="tab subtab" (click)="currentTab = tabChart" [ngClass]="{'active': currentTab == tabChart}">Chart</div>
        <div class="tab subtab" (click)="currentTab = tabTable" [ngClass]="{'active': currentTab == tabTable}">Anomaly table</div>
    </div>
    <apx-chart [hidden]="currentTab !== tabChart" *ngIf="!!nodeId && chartOptions?.series" id="chart" [series]="chartOptions.series"
        [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis" [yaxis]="chartOptions.yaxis"
        [annotations]="chartOptions.annotations"></apx-chart>
    <div [hidden]="currentTab !== tabTable" *ngIf="anomalies.length > 0" class="anomaly-table">
        <div class="anomaly-table-row">
            <div class="anomaly-table-cell">Timestamp</div>
            <div class="anomaly-table-cell">Dst</div>
            <div class="anomaly-table-cell">UCsLd</div>
            <div class="anomaly-table-cell">Qst</div>
            <div class="anomaly-table-cell">UCLq</div>
            <div class="anomaly-table-cell">Features</div>
        </div>
        <div class="anomaly-table-row" *ngFor="let anomaly of anomalies" (click)="onInfoClicked(anomaly)">
            <div class="anomaly-table-cell">{{ anomaly.timestamp }}</div>
            <div class="anomaly-table-cell">{{ anomaly.dStatistic }}</div>
            <div class="anomaly-table-cell">{{ anomaly.dStatisticUCL }}</div>
            <div class="anomaly-table-cell">{{ anomaly.qStatistic }}</div>
            <div class="anomaly-table-cell">{{ anomaly.qStatisticUCL }}</div>
            <div class="anomaly-table-cell">{{ anomaly.features }}</div>
        </div>
    </div>
</div>
